/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_D4dInputs */

const en_mk_sol_konsultan_d4d = /** @type {(inputs: Mk_Sol_Konsultan_D4dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A method that worked is written once, and the next engagement starts from a higher place.`)
};

const id_mk_sol_konsultan_d4d = /** @type {(inputs: Mk_Sol_Konsultan_D4dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cara kerja yang terbukti ditulis sekali, lalu proyek berikutnya memulai dari titik yang lebih tinggi.`)
};

/**
* | output |
* | --- |
* | "A method that worked is written once, and the next engagement starts from a higher place." |
*
* @param {Mk_Sol_Konsultan_D4dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_d4d = /** @type {((inputs?: Mk_Sol_Konsultan_D4dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_D4dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_d4d(inputs)
	return en_mk_sol_konsultan_d4d(inputs)
});